import React from 'react'
import styled from 'styled-components'
import { colors } from 'shared/assets/styles'
import { CaptionText } from 'app/common/typography'
import { FormattedMessage } from 'react-intl'

type Props = {
    errorKey: string,
    values?: { [string]: string | number },
    color?: string,
    className?: string
}

const Error = (props: Props) => {
    const { errorKey, color = colors.red, values, className } = props
    return (
        <ErrorMessage className={className}>
            <FormattedMessage id={errorKey} values={values}>
                {(text: string) => (
                    <CaptionText color={color}>{text}</CaptionText>
                )}
            </FormattedMessage>
        </ErrorMessage>
    )
}

const ErrorMessage = styled.div`
    margin-top: 5px;
    ${CaptionText};
    &.cart-footer {
        margin: 5px 15px 0;
    }
`

export { Error }
